export const UNASSIGNED_FILTER_VALUE = -1;
export const MY_PRIORITY_FILTER_VALUE = -2;

export const PRIORITY_ONLY_STORAGE_KEY = "editingQueueList-priorityOnly";
export const SELECTED_ASSIGNEES_STORAGE_KEY = "editingQueueList-selectedAssignees";

export function parseStoredAssigneeIds(raw: string | null): number[] {
  if (!raw) return [];
  return raw
    .split("|")
    .map(value => parseInt(value, 10))
    .filter(id => Number.isFinite(id) && id !== MY_PRIORITY_FILTER_VALUE);
}

export function parseStoredPriorityOnly(priorityRaw: string | null, assigneesRaw: string | null): boolean {
  if (priorityRaw === "true") return true;
  if (priorityRaw === "false") return false;
  return Boolean(assigneesRaw?.split("|").includes(String(MY_PRIORITY_FILTER_VALUE)));
}
